import { createMapStyle } from '@/map-style';

const centerCoords = import.meta.env.VITE_CENTER_COORDS?.split(',') || [];

export const DEFAULT_CENTER: [number, number] = [
  parseFloat(centerCoords[1] || '13.393707'),
  parseFloat(centerCoords[0] || '52.51831'),
];

export const DEFAULT_ZOOM = 10;

export const maxBounds: [[number, number], [number, number]] | undefined =
  undefined;

export const routeObjects = {
  color: '#c84f2a',
  alternativeColor: '#df8a6f',
  inactiveColor: '#b78c7e',
};

export const MAP_STYLE_STORAGE_KEY = 'selectedMapStyle';
export const CUSTOM_STYLE_STORAGE_KEY = 'customMapStyle';

export const MAP_STYLES = [
  {
    id: 'prawel',
    label: 'Prawel World',
    style: createMapStyle(),
  },
] as const;

export const DEFAULT_MAP_STYLE = MAP_STYLES[0].style;
export const DEFAULT_MAP_STYLE_ID = MAP_STYLES[0].id;
export const MAP_STYLE_IDS = MAP_STYLES.map((s) => s.id);
export const CLICK_DELAY_MS = 200;
export const DOUBLE_TAP_THRESHOLD_MS = 300;
